import { z } from 'zod'

import { dbEntitySchema } from './system'

export const ticketFileSchema = dbEntitySchema.extend({
  booking: z.string().optional(),
  admissionGroup: z.string().optional(),
  tickets: z.array(z.string()),
  key: z.string(),
  bucket: z.string(),
  name: z.string(),
  url: z.string(),
})
